import React from "react";

const Footer = () => {
  return (
    <footer className='pb-10 footer'>
      <div className='relative flex-col'>
        <div className='text-base leading-6 '>
          <div className='flex flex-wrap justify-between space-x-8'>
            <div class='flex flex-grow-1 items-center px-6 py-6 space-x-4'>
              <div class='py-4'>
                <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32'>
                  <g fill='none' fill-rule='evenodd'>
                    <path fill='#0062FF' d='M16 0v16H0z'></path>
                    <path fill='#00F5F0' d='M16 32V16h16z'></path>
                  </g>
                </svg>
              </div>
              <div class='dark:text-white font-light mt-2 text-gray-600 text-sm'>
                © 2020 TailReact , all rights reserved
              </div>
            </div>
            <div className='px-6 py-6 space-y-2 text-sm font-light text-gray-400'>
              <div className='font-medium text-gray-700 uppercase dark:text-gray-200'>
                Company
              </div>
              <ul className='flex-col space-y-1'>
                <li>
                  <a href='#/' className='hover:underline'>
                    Dummy text used
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    The purpose of lorem
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    Filler text can be very useful
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    Be on design
                  </a>
                </li>
              </ul>
            </div>
            <div className='px-6 py-6 space-y-2 text-sm font-light text-gray-400'>
              <div className='font-medium text-gray-700 uppercase dark:text-gray-200'>
                Support
              </div>
              <ul className='flex-col space-y-1'>
                <li>
                  <a href='#/' className='hover:underline'>
                    Dummy text used
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    The purpose of lorem
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    Filler text can be very useful
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    Be on design
                  </a>
                </li>
              </ul>
            </div>
            <div className='px-6 py-6 space-y-2 text-sm font-light text-gray-400'>
              <div className='font-medium text-gray-700 uppercase dark:text-gray-200'>
                Contacts
              </div>
              <ul className='flex-col space-y-1'>
                <li>
                  <a href='#/' className='hover:underline'>
                    Dummy text used
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    The purpose of lorem
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    Filler text can be very useful
                  </a>
                </li>
                <li>
                  <a href='#/' className='hover:underline'>
                    Be on design
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='items-center justify-center pt-4 lg:flex lg:justify-between'>
          <nav className='rl'>
            <ul className='flex items-center justify-center my-4 space-x-4 lg:justify-between lg:my-0'>
              <li>
                <a
                  href='#/'
                  className='text-sm font-light text-gray-600 dark:text-ebony-400 dark:hover:text-ebony-200 hover:underline'>
                  Contact
                </a>
              </li>
              <li>
                <a
                  href='#/'
                  className='text-sm font-light text-gray-600 dark:text-ebony-400 dark:hover:text-ebony-200 hover:underline'>
                  About us
                </a>
              </li>
              <li>
                <a
                  href='#/'
                  className='text-sm font-light text-gray-600 dark:text-ebony-400 dark:hover:text-ebony-200 hover:underline'>
                  FAQ's
                </a>
              </li>
              <li>
                <a
                  href='#/'
                  className='text-sm font-light text-gray-600 dark:text-ebony-400 dark:hover:text-ebony-200 hover:underline'>
                  Support
                </a>
              </li>
            </ul>
          </nav>
          <div className=''>
            <ul className='flex items-center justify-center lg:justify-between'>
              <li className='px-4'>
                <a href='https://www.linkedin.com/in/alhassan-ali-055294134/'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 16 16'
                    className='w-4 text-blue-600 fill-current h- hover:text-blue-400'>
                    <defs />
                    <path d='M15 0H1L0 1v14l1 1h14l1-1V1l-1-1zM5 14H2V6h3v8zM4 5L2 4l2-2 1 2-1 1zm10 9h-3v-4l-1-2-1 2v4H6V6h3v1l2-1c2 0 2 1 2 3v5h1z' />
                  </svg>
                </a>
              </li>
              <li className='px-4'>
                <a href='https://www.pinterest.com/hassankotti/'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 16 16'
                    className='w-4 text-blue-600 fill-current h- hover:text-blue-400'>
                    <defs />
                    <path d='M8 0C4 0 0 4 0 8c0 3 2 6 5 7v-2l1-4V8l1-2 1 1v3c-1 1 0 1 1 1s2-1 2-3-1-4-3-4-4 2-4 4l1 2v1H4L4 8c0-3 2-5 5-5s5 2 5 5c0 2-2 5-4 5l-2-1v2l-1 2h2c4 0 8-4 8-8s-4-8-8-8z' />
                  </svg>
                </a>
              </li>
              <li className='px-4'>
                <a href='https://github.com/hassanKotti/tailreact'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 16 16'
                    className='w-4 text-blue-600 fill-current h- hover:text-blue-400'>
                    <defs />
                    <path d='M8 0C4 0 0 4 0 8c0 3 2 6 5 8l1-1v-1l-3-1-1-1v-1l2 1 2 1v-2c-1 0-3 0-3-4l1-2V3l2 1a6 6 0 012 0h2l2-1v2l1 2c0 4-2 4-4 4l1 2v2l1 1c3-2 5-5 5-8 0-4-4-8-8-8z' />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
          <div className='mt-4 text-sm font-light text-center text-gray-600 dark:text-white lg:hidden'>
            © 2021 TailReact, all rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
